export default __webpack_public_path__ + "static/media/YOOZ_BILL_PAYMENT_REQUIREMENT_POST.8da5f1a5.jpg";